import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash-es';
import translate from '../jsons/translate.json';

@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {

    transform(value: string) {
        return get((translate as any), value) || value
    }
}
